import React, { memo, useState } from 'react';
import { ModalWrapper } from '@components-library/Modals/ModalWrapper';
import { BaseEditor } from '@components-shared/HtmlEditor';

interface IHtmlEditorProps {
  onChange: (v: string) => void;
  value: string;
  title: string;
}
export const EditableHTMLModal = memo((props: IHtmlEditorProps): JSX.Element => {
  const { value, onChange, title } = props;
  const [showPopup, setShowPopup] = useState<boolean>(false);

  const toggleModal = () => {
    setShowPopup(!showPopup);
  };

  const renderHtmlEditorModal = () => {
    return (
      <ModalWrapper title={title} closeHandler={toggleModal}>
        <BaseEditor value={value} onChange={onChange} isNeedPreview={false} />
      </ModalWrapper>
    );
  };

  return (
    <>
      <input onClick={toggleModal} value={value} style={{ cursor: 'pointer' }} />
      {showPopup && renderHtmlEditorModal()}
    </>
  );
});
